import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function EstimateFlowSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={pricingData.estimateFlow.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {pricingData.estimateFlow.title}
          </h2>
        </div>

        <div className="reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8">
          {pricingData.estimateFlow.steps.map((step, idx) => (
            <div
              key={step.num}
              className="relative bg-background-100 rounded-lg border border-background-200/70 p-5 md:p-6 text-center"
            >
              {idx < 3 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-6 h-6">
                  <i className="ri-arrow-right-s-line text-lg text-primary-300" />
                </div>
              )}

              <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center mx-auto mb-4">
                <span className="text-sm font-bold text-background-50 font-heading">{step.num}</span>
              </div>

              <h4 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                {step.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Mid CTA */}
        <div className="reveal text-center mb-6">
          <button
            onClick={() => {
              const el = document.querySelector("#contact");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            料金・支援内容について相談する
            <i className="ri-arrow-right-line" />
          </button>
        </div>

        <div className="reveal text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-background-100 border border-background-200/70">
            <i className="ri-information-line text-primary-500" />
            <p className="text-sm text-foreground-600">{pricingData.estimateFlow.note}</p>
          </div>
        </div>
      </div>
    </section>
  );
}